import React from 'react';
import { Skeleton } from 'antd';
import './skeletons.css';

/**
 * FormSkeleton Component
 *
 * Displays a skeleton loading state for forms (modals, dialogs, etc.).
 * Shows a structured placeholder with title, form fields, and action buttons.
 *
 * @param {number} fields - Number of form fields to display (default: 3)
 * @param {boolean} showTitle - Whether to show title skeleton (default: true)
 * @param {boolean} showButtons - Whether to show button skeletons (default: true)
 * @param {number} buttons - Number of buttons to show (default: 2)
 */
const FormSkeleton = ({
  fields = 3,
  showTitle = true,
  showButtons = true,
  buttons = 2
}) => {
  return (
    <div className="form-skeleton-container">
      {/* Title Skeleton */}
      {showTitle && (
        <div className="form-skeleton-title">
          <Skeleton.Input active size="default" style={{ width: '180px' }} />
        </div>
      )}

      {/* Divider */}
      {showTitle && <div className="form-skeleton-divider"></div>}

      {/* Form Fields Skeleton */}
      <div className="form-skeleton-fields">
        {Array.from({ length: fields }).map((_, index) => (
          <div key={`field-${index}`} className="form-skeleton-field">
            {/* Label Skeleton */}
            <div className="form-skeleton-label">
              <Skeleton.Input active size="small" style={{ width: '80px', height: '16px' }} />
            </div>
            {/* Input Skeleton */}
            <div className="form-skeleton-input">
              <Skeleton.Input active size="default" style={{ width: '100%', height: '40px' }} />
            </div>
          </div>
        ))}
      </div>

      {/* Buttons Skeleton */}
      {showButtons && (
        <div className="form-skeleton-buttons">
          {Array.from({ length: buttons }).map((_, index) => (
            <div key={`button-${index}`} className="form-skeleton-button">
              <Skeleton.Button
                active
                size="large"
                style={{ width: '100%', height: '40px' }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FormSkeleton;
